<template>
  <!-- 导航菜单 -->
  <div id="appsNav">
    <div class="tab-choose">
      <van-tabs v-model="activeName"
              @click="navChange"
              @disabled="onClickDisabled"
              line-width="30"
              title-active-color="#0084FF"
              title-inactive-color="#000000">
      <van-tab title="政策法规"
               v-if="accountstatus == 300 || accountstatus == 400"
               name="a"
               disabled></van-tab>
      <van-tab title="政策法规"
               v-else
               name="a"></van-tab>
      
      <van-tab title="官方解答"
               v-if="accountstatus == 300 || accountstatus == 400"
               name="z"
               disabled></van-tab>
      <van-tab title="官方解答"
               v-else
               name="z"></van-tab>

      <van-tab title="搜索引擎"
               v-if="accountstatus == 300 || accountstatus == 400"
               name="b"
               disabled></van-tab>
      <van-tab title="搜索引擎"
               v-else
               name="b"></van-tab>
      
      <van-tab title="AI问答"
               v-if="accountstatus == 300 || accountstatus == 400"
               name="ch"
               disabled></van-tab>
      <van-tab title="AI问答" 
               name="ch" title-style="color:red;"></van-tab>    

      <van-tab title="涉税判例"
               v-if="accountstatus == 300 || accountstatus == 400"
               name="m"
               disabled></van-tab>
      <van-tab title="涉税判例"
               v-else
               name="m"></van-tab>
      
      <van-tab title="涉税表单"
               v-if="accountstatus == 300 || accountstatus == 400"
               name="q"
               disabled></van-tab>
      <van-tab title="涉税表单"
               v-else
               name="q"></van-tab>


      <van-tab title="税务案例"
                v-if="accountstatus == 300 || accountstatus == 400"
                name="n"
                disabled></van-tab>
      <van-tab title="税务案例"
                v-else
                name="n"></van-tab>

      <!-- <van-tab title="专家解读"
                v-if="accountstatus == 300 || accountstatus == 400"
                name="p"
                disabled></van-tab>
      <van-tab title="专家解读"
                v-else
                name="p"></van-tab> -->
      
      <van-tab title="智慧云端"
               v-if="accountstatus == 300 || accountstatus == 400"
               name="c"
               disabled></van-tab>
      <van-tab title="智慧云端"
               v-else
               name="c"
               to="smartcloud"></van-tab>
      <!-- <van-tab title="优惠政策匹配"
               v-if="accountstatus == 300 || accountstatus == 400"
               name="r"
               disabled></van-tab> -->
      <van-tab title="优惠匹配"
               name="r"
               to="policyMate"></van-tab>

      <van-tab title="在线商城"
               name="d"
               v-if="this.$store.state.user.permissionArray.includes('900001')"
               to="/onlineMall"></van-tab>
      <van-tab title="在线商城"
               name="d"
               v-else
               disabled></van-tab>

      <van-tab title="账号中心"
               v-if="accountstatus == 300 || accountstatus == 400"
               name="h"
               disabled></van-tab>
      <van-tab title="账号中心"
               v-else
               name="h"
               to="personalCenter"></van-tab>
      <van-tab title="特别声明"
               v-if="accountstatus == 300 || accountstatus == 400"
               name="g"
               disabled></van-tab>
      <van-tab title="特别声明"
               v-else
               name="g"
               to="importantClause"></van-tab>
      </van-tabs>
      <div v-if="!showNav" class="down-btn" @click="changeOpenSta">
        <van-icon name="arrow-down" />
      </div>
      <div v-else class="up-btn" @click="changeOpenSta">
        <van-icon name="arrow-up" />
      </div>
    </div>
    <van-popup v-model="showNav"
      overlay-class="more-nav-overlay">
      <div class="more-nav">
        <span class="all nav-item">全部分类</span>
        <span class="nav-item" 
          :class="changedNav == 'a' ? 'chosed-item': ''" 
          @click="changeNav('a')">
          政策法规
        </span>
        <span class="nav-item"
          :class="changedNav == 'z' ? 'chosed-item': ''" 
          @click="changeNav('z')">官方解答
        </span>
        <span class="nav-item"
          :class="changedNav == 'b' ? 'chosed-item': ''"
          @click="changeNav('b')">搜索引擎</span>
        <span class="nav-item"
          :class="changedNav == 'ch' ? 'chosed-item':'ai-item'"
          @click="changeNav('ch')">AI问答</span>
        <span class="nav-item"
          :class="changedNav == 'm' ? 'chosed-item': ''"
          @click="changeNav('m')">涉税判例</span>
        <span class="nav-item"
        :class="changedNav == 'q' ? 'chosed-item': ''"
        @click="changeNav('q')">涉税表单</span>
        <span class="nav-item"
          :class="changedNav == 'n' ? 'chosed-item': ''"
          @click="changeNav('n')">税务案例</span>
        <!-- <span class="nav-item"
          :class="changedNav == 'p' ? 'chosed-item': ''"
          @click="changeNav('p')">专家解读</span> -->
        <span class="nav-item"
          :class="changedNav == 'c' ? 'chosed-item': ''"
          @click="changeNav('c')">智慧云端</span>
        <span class="nav-item"
          :class="changedNav == 'r' ? 'chosed-item': ''"
          @click="changeNav('r')">优惠匹配</span>

        <span class="nav-item"
          :class="changedNav == 'd' ? 'chosed-item': ''"
          @click="changeNav('d')">在线商城</span>
        <span class="nav-item"
          :class="changedNav == 'h' ? 'chosed-item': ''"
          @click="changeNav('h')">账号中心</span>
        <span class="nav-item"
          :class="changedNav == 'g' ? 'chosed-item': ''"
          @click="changeNav('g')">特别声明</span>
      </div>
    </van-popup>
    
    <login  ref="alertModel"></login>
  </div>
</template>

<script>
import Login from "@/components/common/login";
import { commonToast } from "@/utils/lib/toast.js";
import { test } from "../../public/config.json";
export default {
  data () {
    return {
      flag: false,
      showNav: false,
      changedNav: 'a' // 当前选中的nav
    };
  },
  components: {
    Login,
  },
  computed: {
    test_user() { 
      return test
    },
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    userId () {
      return this.$store.state.user.userId;
    },
    activeName: {
      get () {
        return this.$store.state.commonSearchData.activeName;
      },
      set () {
        // this.$store.commit('commonSearchData/changeActiveName', localStorage.getItem('selectedId'))
      },
    },
    // 获取版本
    getVersion () {
      return this.$store.state.changeVersion.changeFlag;
    },
    getVersionWord () {
      return this.$store.state.changeVersion.changeWord;
    },
    accountstatus () {
      return this.$store.state.user.accountstatus;
    },
    accounttype () {
      return this.$store.state.user.accounttype;
    },
  },
  methods: {
    navChange (name, title) {
      console.log(
        "name",
        name,
        title,
        this.getVersion,
        this.getVersionWord,
        this.$store.state.changeVersion
      );
      this.changedNav = name
      if (name === "a") {
        this.$router.push("newFiles");
        this.showNav = false
      } else if (name === "b") {
        this.$router.push("newSearchEngine");
        this.showNav = false
      } else if (name === 'z') {
        this.$router.push("answer")
        this.showNav = false
      } else if (name === 'm') {
        this.$router.push("judgeCase")
        this.showNav = false
      } else if (name === 'n') {
        this.$router.push("taxCase")
        this.showNav = false
      } else if (name === 'p') {
        this.$router.push("expertAnswer")
        this.showNav = false
      } else if (name === 'r') {
        this.$router.push("policyMate")
        this.showNav = false
      } else if (name === 'ch') {
        this.$router.push("chatai")
        this.showNav = false
      } else if (name === 'q') {
        this.$router.push("taxForm")
        this.showNav = false
      } else if (
        ((name === "c" || name === "d" || name === "h") &&
        !this.userId &&
        !this.wxgenerateid)
      ) {
        this.$refs.alertModel.changeShowLogin(true); // 弹出登录框
      }
    },
    changeNav(name) {
      this.changedNav = name
      if (name === "a") {
        this.$router.push("newFiles");
        this.showNav = false
      } else if (name === 'z') {
        this.$router.push("answer")
        this.showNav = false
      }else if (name === "ch") {
        this.$router.push("chatai");
        this.showNav = false
      } else if (name === "b") {
        this.$router.push("newSearchEngine");
        this.showNav = false
      }
        else if (name === 'm') {
        this.$router.push("judgeCase")
        this.showNav = false
      } else if (name === 'n') {
        this.$router.push("taxCase")
        this.showNav = false
      } else if (name === 'q') {
        this.$router.push("taxForm")
        this.showNav = false
      } else if (name === 'r') {
        this.$router.push("policyMate")
        this.showNav = false
      } else if (name === 'ch') {
        this.$router.push("chatai")
        this.showNav = false
      }else if (
        ((name === "c" || name === "d" || name === "h") &&
        !this.userId &&
        !this.wxgenerateid)
      ) {
        this.$refs.alertModel.changeShowLogin(true); // 弹出登录框
      } else if ((name === 'c')  && (this.userId || this.wxgenerateid)) {
        this.$router.push("smartcloud")
        this.showNav = false
      } else if ((name === 'd')  && (this.userId || this.wxgenerateid)) {
        console.log('thr')
        this.$router.push("onlineMall")
        this.showNav = false
      } else if ((name === 'h')  && (this.userId || this.wxgenerateid)) {
        this.$router.push("personalCenter")
        this.showNav = false
      } else if ((name === 'g')  && (this.userId || this.wxgenerateid)) {
        this.$router.push("importantClause")
        this.showNav = false
      }
    },
    onClickDisabled (name, title) {
      console.log("name, title", name, title);
      if (name === "d") {
        commonToast("请登录后再使用此功能", this);
        this.$refs.alertModel.changeShowLogin(true);
      } else {
        commonToast("请先前往在线商城购买产品后使用", this);
      }
    },
    changeOpenSta() {
      this.showNav = !this.showNav
    }
  },
};
</script>
<style lang="less">

#appsNav {
  .tab-choose {
    .van-tab:nth-child(11) {
      .van-tab__text {
        padding-right: 10px;
      }
    }
  }
  
  .van-tab__text {
    font-size: 15px;
  }
  .tab-choose {
    position: relative;
    
    .down-btn, .up-btn {
      position: absolute;
      top: 0px;
      right: 0px;
      z-index: 100;
      width: 30px;
      height: 30px;
      text-align: center;
      padding-top: 15px;
      background-color: #fff;
    }
  }
  .more-nav-overlay {
    top: 92px;
  }
  .van-popup {
    top: 140px;
    width: 100%;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .more-nav {
    background-color: white;
    z-index: 3000;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 5px;
    text-align:justify;
    text-align-last:left;
    
    .nav-item {
      background-color:#F2F2F2;
      border-radius: 30px;
      color: #000000;
      margin: 4px;
      padding: 2px 4px;
      display: flex;
      justify-content: center;
      border: 1px solid transparent;
      width: calc(100% / 5 - 18px);
      letter-spacing: -1px;
    }
    .all {
      background-color: #fff;
    }
    .chosed-item {
      border: 1px solid#0084FF;
      color:#0084FF;
      background-color: white;
    }
    .ai-item {
      // border: 1px solid#F53F3F;
      color:#F53F3F;
      background-color: white;
    }
  }
}
</style>
